import { Directive } from "@app/components/directive";
import { IExpanderScope } from "@app/components/kb-expander/kb-expander.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IExpanderGroupScope extends ng.IScope {
    accordion?: boolean;
    _expanders?: IExpanderScope[];
    element: ng.IAugmentedJQuery;
}

export interface IExpanderGroupController {
    scope: IExpanderGroupScope;
    registerExpander: (node: IExpanderScope) => void;
    expand: (e: IExpanderScope) => void;
}

@NgComponent({
    token: Token.KbExpanderGroup
})
export class KbExpanderGroup extends Directive {
    constructor() {

        super();

        this.replace = false;
        this.template = Dirs.component("kb-expander-group");
        this.restrict = "E";
        this.scope = {
            accordion: "=?"
        };
        this.transclude = true;

        // // add scope defaults to the compile function
        // this.compile = (element, atts: any) => {
        //     if (!angular.isDefined(atts.accordion)) atts.selectable = "true";
        //     if (!angular.isDefined(atts.expandable)) atts.expandable = "true";
        // };

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            function (
                $scope: IExpanderGroupScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes) {
                // set the scope of the tree on it's controller so children can access it
                this.scope = $scope;
                $scope.element = $element;
                $scope._expanders = [];

                // all child nodes register themselves with the tree to handle selection and accordion functionality
                this.registerExpander = (e: IExpanderScope) => {
                    $scope._expanders.push(e);
                    let off = e.$on("$destroy", event => {
                        $scope._expanders.remove(e);
                        off();
                    });
                    if ($scope.accordion) {
                        for (let expander of $scope._expanders) {
                            if (expander.expanded) {
                                updateExpanders(expander);
                                return;
                            }
                        }
                    }
                };

                this.expand = (e: IExpanderScope) => {
                    if (e.expanded) updateExpanders(e);
                };

                let updateExpanders = (activeExpander: IExpanderScope) => {
                    if ($scope.accordion) {
                        for (let e of $scope._expanders) {
                            if (e !== activeExpander) e.expanded = false;
                        }
                    }
                };                
            }];
    }

}
